import { ValidationService } from 'aspnet-client-validation';

export class CustomValidationService {
    private validationService: ValidationService;

    constructor() {
        this.validationService = new ValidationService();
    }

    public initialize(): void {
        this.validationService.bootstrap();
        this.setupCustomProviders();

        // jQuery Validate adapter registration must be deferred until DOM is ready
        // because jQuery itself is loaded via a script tag, not bundled
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setupJQueryAdapters());
        } else {
            this.setupJQueryAdapters();
        }
    }

    private setupJQueryAdapters(): void {
        const $: any = (window as any).$;
        if (!$ || !$.validator || !$.validator.unobtrusive) return;

        // Register the requiredif validation method so jQuery Validate understands
        // fields decorated with [RequiredIf] when $form.valid() is called directly
        $.validator.addMethod('requiredif', function (value: string, _element: HTMLElement, params: any) {
            const other = document.querySelector<HTMLInputElement>('#' + params.otherproperty);
            if (!other) return true;

            const otherValue = other.type === 'checkbox'
                ? other.checked.toString()
                : other.value;

            if (otherValue.toLowerCase() === (params.otherpropertyvalue ?? '').toLowerCase()) {
                return value !== null && value !== undefined && value.trim() !== '';
            }

            return true;
        }, '');  // message comes from the unobtrusive adapter

        $.validator.unobtrusive.adapters.add('requiredif', ['otherproperty', 'otherpropertyvalue'], function (options: any) {
            options.rules['requiredif'] = {
                otherproperty: options.params.otherproperty,
                otherpropertyvalue: options.params.otherpropertyvalue
            };
            options.messages['requiredif'] = options.message;
        });
    }

    private setupCustomProviders(): void {
        this.setupMinimumAgeProvider();
        this.setupRequiredIfProvider();
    }

    private setupMinimumAgeProvider(): void {
        this.validationService.addProvider('minimumage', (value, _element, params) => {
            let date = new Date(value);
            let today = new Date();

            let minimumAge = parseInt(params['age']) ?? 18;
            let age = today.getFullYear() - date.getFullYear();
            let monthDiff = today.getMonth() - date.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
                age--;
            }

            return age >= minimumAge;
        });
    }

    private setupRequiredIfProvider(): void {
        this.validationService.addProvider('requiredif', (value, _element, params) => {
            const targetId = params.otherproperty;
            const targetValue = params.otherpropertyvalue;
            const otherPropertyValue = (targetValue ?? '').toString();
            const otherPropertyElement = document.querySelector('#' + targetId) as HTMLInputElement;

            if (otherPropertyElement && otherPropertyElement.checked.toString() === otherPropertyValue.toLowerCase()) {
                return value !== '';
            }

            return true;
        });
    }
}
